<template>
    <div>
        <section class="section section-lg section-shaped overflow-hidden my-0">
            <div class="shape shape-style-1 shape-orange shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container py-3 pb-lg">
                <div class="row justify-content-between align-items-center">
                    <div class="col-lg-5 mb-5 mb-lg-0">
                        <h1 class="text-white">Norcross Art Gallery</h1>
                        <p class="lead text-white mt-4">{{intro}}</p>
                        <base-button tag="a"
                                     v-on:click="tracker('Booking', 'Redirected to booking', 'Art Gallery page info - top')"
                                     href="https://offthecouch.io/book/otc" type="white" class="mt-4">
                            Book now
                        </base-button>
                    </div>
                    <div class="col-lg-6 mt-5 mb-lg-auto">
                        <div class="rounded shadow-lg overflow-hidden transform-perspective-right">
                            <b-carousel id="carousel1"
                                        controls
                                        indicators>
                                <!-- Text slides with image -->
                                <b-carousel-slide img-src="img/brand/asheville/gallery/ArtGallery2.jpg"></b-carousel-slide>
                                <b-carousel-slide img-src="img/brand/asheville/gallery/ArtGallery3.jpg"></b-carousel-slide>
                                <b-carousel-slide img-src="img/brand/asheville/gallery/ArtGallery4.jpg"></b-carousel-slide>
                            </b-carousel>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="games" class="section section-lg pt-lg-0 mt--150">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-12">
                                <div class="card white shadow border-0">
                                    <img v-lazy="'img/brand/asheville/gallery/ArtGallery1.jpg'" class="card-img-top fixed-height">
                                </div>
                                <card class="border-0" shadow>
                                    <div class="row ml-2">
                                        <div class="mb-4 d-flex align-right">
                                            <icon name="ni ni-single-02" class="bg-gradient-white" color="warning" shadow rounded></icon>
                                            <span class="mt-3 ml-3 mr-5 text-warning text-uppercase font-weight-bold">{{players}}</span>
                                        </div>
<!--                                        <div class="mb-4 d-flex align-right">-->
<!--                                            <icon name="ni ni-trophy" class="bg-gradient-white" color="warning" shadow rounded></icon>-->
<!--                                            <span class="mt-3 mr-4 ml-3 text-warning text-uppercase font-weight-bold">{{difficulty}}</span>-->

<!--                                        </div>-->
                                        <div class="mb-4 d-flex align-right">
                                            <icon name="ni ni-time-alarm" class="bg-gradient-white" color="warning" shadow rounded></icon>
                                            <span class="mt-3 ml-3 text-warning text-uppercase font-weight-bold">{{duration}}</span>
                                        </div>
                                    </div>
                                    <h4 class="mt-2 text-warning">Chapter 2: Norcross Art Gallery</h4>
                                    <p class="mt-2">{{description}}</p>
                                  <p class=" text-warning text-uppercase font-weight-bold">{{disclaimer6}}</p>
                                    <p class="mt-3">
                                        <span class=" text-warning text-uppercase font-weight-bold">{{disclaimer}}</span>
                                        {{disclaimer2}}

                                    </p>
                                  <p class="mt-3">
                                    <span class=" text-warning text-uppercase font-weight-bold">{{disclaimer4}}</span>
                                    {{disclaimer5}}
                                  </p>
                                    <p>
                                        <strong>{{disclaimer3}}</strong>
                                    </p>
                                    <base-button tag="a"
                                                 v-on:click="tracker('Booking', 'Redirected to booking', 'Art Gallery page info - bottom')"
                                                 href="https://offthecouch.io/book/otc" type="white" class="mt-2 mb-2">
                                        Book now
                                    </base-button>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
    import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";
    export default {
        name: "Gallery",
        components: {BCarousel, BCarouselSlide},
        data () {
            return {
                description: "Having investigated Occam's Apartment, you decided to follow the leads that were left behind and determined that the Norcross Art Gallery is where \"he\" likely is operating out of.",
                disclaimer: "ALL BOOKINGS ARE PRIVATE. ",
                disclaimer2: "Only your group will be in the game.",
                disclaimer3: "This is the second of twelve chapters, with each chapter ranging in length from 90-180 minutes. It is recommended that players complete this chapter before proceeding into Asheville: The Morgue. If you would like to book more than 90 minutes, please contact us. Note that if you do not complete the chapter within 90 minutes, your progress is saved and you will resume where you left off when you return. Any remaining time at the end of the chapter is credited back to your account to be used for future bookings.",
                disclaimer4: "GAME IS NOT SUITABLE FOR CHILDREN, ",
                disclaimer5: "please contact us if you have any questions.",
                disclaimer6: "HIGHLY RECOMMENDED YOU PLAY CHAPTER 1: OCCAM'S APARTMENT BEFORE PLAYING THIS CHAPTER.",
                players: "2-6",
                difficulty: "Difficult",
                duration: "90 minutes",
                intro: "You followed leads that were left behind at Occam's Apartment and determined that the Norcross Art Gallery is where \"he\" likely is operating out of."
            }
        },
        methods: {
            tracker(category, action, label) {
                this.$ga.event(category, action, label)
            }
        }
    }
</script>

<style scoped>
.fixed-height{
  width: 100%; /* width of container */
  height: 300px; /* height of container */
  object-fit: cover;
}
</style>
